import { render, staticRenderFns } from "./EditAggregator.vue?vue&type=template&id=6d568d1e"
import script from "./EditAggregator.vue?vue&type=script&lang=js"
export * from "./EditAggregator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports